import React from 'react'
import Gym from '../assets/GYM.png'
import quizApp from '../assets/quizApp.jpg'
import recipeApp from '../assets/recipeApp1.png'
import starTech from '../assets/starTech.png'
import weatherApp from '../assets/weatherApp.jpg'
import digitalAgency from '../assets/digitalAgency.png'
import { HiArrowNarrowRight } from 'react-icons/hi'

function Projects() {
    return (
        <div name='projects' className='bg-[#0a192f] w-full md:h-screen text-gray-300'>
            {/* Container */}
            <div className='max-w-[1000px] mx-auto p-4 justify-center flex flex-col w-full h-full'>
                {/* Title */}
                <div className='text-center pb-10 my-3'>
                    <p className='text-4xl font-bold inline border-b-4 border-pink-600'>Projects</p>
                </div>

                {/* Projects Area */}
                <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-8'>

                    {/* Project-card */}
                    <div className='scrolling-image'>
                        <img src={Gym} alt="Gym" />
                        {/* Hover Effects */}
                        <div className='project-content'>
                            <span className='text-2xl font-bold text-white'>STAR GYM</span>
                            <div className='pt-3 flex'>
                                <a href="https://crazygym.netlify.app/" target="_blank" rel="noreferrer">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Live</button>
                                </a>
                                <a href="https://github.com/STARBOY05/STAR-GYM" target="_blank" rel="noreferrer">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Code</button>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Projects Card */}
                    <div className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div' style={{ backgroundImage: `url(${weatherApp})` }}>
                        {/* Hover Effects */}
                        <div className='opacity-0 group-hover:opacity-100 text-center'>
                            <span className='text-2xl font-bold text-white'>WEATHER APP</span>
                            <div className='pt-8 text-center'>
                                <a href="https://tempclimate.netlify.app/">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Live</button>
                                </a>
                                <a href="https://github.com/STARBOY05/weather-app">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Code</button>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Projects Card */}
                    <div className='scrolling-image'>
                        <img src={digitalAgency} alt="digitalAgency" />
                        {/* Hover Effects */}
                        <div className='project-content'>
                            <span className='text-xl font-bold text-white'>DIGITAL AGENCY</span>
                            <div className='pt-3 flex'>
                                <a href="https://crazygym.netlify.app/" target="_blank" rel="noreferrer">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Live</button>
                                </a>
                                <a href="https://github.com/STARBOY05/STAR-GYM" target="_blank" rel="noreferrer">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Code</button>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Projects Card */}
                    <div className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div' style={{ backgroundImage: `url(${quizApp})` }}>
                        {/* Hover Effects */}
                        <div className='opacity-0 group-hover:opacity-100 text-center'>
                            <span className='text-2xl font-bold text-white'>QUIZ APP</span>
                            <div className='pt-8 text-center'>
                                <a href="https://quizmasters.netlify.app/">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Live</button>
                                </a>
                                <a href="https://github.com/STARBOY05/quiz-app">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Code</button>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Project-card */}
                    <div className='scrolling-image'>
                        <img src={starTech} alt="starTech" />
                        {/* Hover Effects */}
                        <div className='project-content'>
                            <span className='text-2xl font-bold text-white'>STAR TECH</span>
                            <div className='pt-3 flex'>
                                <a href="/" target="_blank" rel="noreferrer">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Live</button>
                                </a>
                                <a href="/" target="_blank" rel="noreferrer">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Code</button>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Project-card */}
                    <div className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div' style={{ backgroundImage: `url(${recipeApp})` }}>
                        {/* Hover Effects */}
                        <div className='opacity-0 group-hover:opacity-100 text-center'>
                            <span className='text-2xl font-bold text-white'>RECIPE APP</span>
                            <div className='pt-8 text-center'>
                                <a href="/">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Live</button>
                                </a>
                                <a href="https://github.com/STARBOY05/food_recipe">
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Code</button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-[100%] my-5 flex justify-center items-center'>
                    <button className='text-white border-2 px-6 py-3 my-2 flex justify-between items-center hover:bg-pink-600 hover:border-pink-600 duration-300 transition-ease-in'><a href='https://github.com/STARBOY05' target='_blank' rel="noreferrer">More on Github</a><HiArrowNarrowRight className='ml-3' /> </button>
                </div>
            </div>
        </div>
    )
}

export default Projects